// 'members' 영역 문구. 키는 ko / en 에 똑같이 둔다.
const members = {
  ko: {
    eyebrow: 'Members',
    title: '회원 관리',
    desc: '참가 신청한 회원은 이름과 연락처로 구분됩니다. 회원을 선택하면 개인정보와 대회기록을 확인할 수 있습니다.',
    listTitle: '회원 목록',
    searchPlaceholder: '이름 · 연락처 · 도장명',
    noSearchResults: '검색 결과가 없습니다.',
    noMembers: '등록된 회원이 없습니다.',
    applicationCount: '신청 {count}회',
    idChip: 'ID {id}',
    prev: '이전',
    next: '다음',
    selectPrompt: '왼쪽 목록에서 회원을 선택해 주세요.',
    subtitle: '회원 ID {id} · 등록 {date}',
    edit: '정보 수정',
    saving: '저장 중...',
    notSelected: '선택 안 함',
    loadListError: '회원 목록을 불러오지 못했습니다.',
    loadDetailError: '회원 정보를 불러오지 못했습니다.',
    saveError: '회원 정보를 저장하지 못했습니다.',
    requiredFields: '이름과 연락처는 필수입니다.',
    fields: {
      name: '이름',
      phone: '연락처',
      birth: '생년월일',
      gender: '성별',
      parentPhone: '보호자 연락처',
      association: '소속 협회',
      gym: '도장명',
      coach: '지도자명',
      grade: '학년',
      height: '신장',
      heightCm: '신장(cm)',
      memo: '관리자 메모',
    },
    required: '{label} *',
    records: {
      title: '대회기록 ({count})',
      empty: '대회기록이 없습니다.',
      columns: {
        competition: '대회',
        eventAt: '개최일',
        gym: '도장',
        grade: '학년',
        height: '신장',
        division: '부문',
        rank: '순위',
        record: '전적',
        scoreSum: '점수 합계',
        payment: '결제',
        matches: '경기',
      },
      matchCount: '{count}경기',
      rank: {
        first: '🥇 우승',
        second: '🥈 준우승',
        third: '🥉 3위',
        nth: '{rank}위',
      },
      winLoss: '{wins}승 {losses}패',
      score: '{total} (머리 {head} · 몸통 {body})',
    },
    matches: {
      columns: {
        round: '라운드',
        opponent: '상대',
        myScore: '내 점수',
        opponentScore: '상대 점수',
        result: '결과',
      },
      result: {
        WIN: '승',
        LOSS: '패',
        BYE: '부전승',
        pending: '진행 전',
      },
    },
    merge: {
      title: '중복 회원 병합',
      desc: '이름 오타 등으로 같은 사람이 두 회원으로 나뉜 경우, 이 회원의 신청·대회기록을 다른 회원으로 옮기고 이 회원을 삭제합니다.',
      targetPlaceholder: '대상 회원 ID',
      button: '병합',
      targetRequired: '병합할 대상 회원 ID를 입력해 주세요.',
      confirm:
        '{name} 님(ID {id})의 신청·대회기록을 회원 ID {targetId} 로 옮기고, 현재 회원은 삭제합니다.\n계속하시겠습니까?',
      error: '회원을 병합하지 못했습니다.',
    },
  },
  en: {
    eyebrow: 'Members',
    title: 'Member management',
    desc: 'Members who registered are identified by name and phone. Select a member to see their details and tournament records.',
    listTitle: 'Members',
    searchPlaceholder: 'Name · Phone · Gym',
    noSearchResults: 'No results found.',
    noMembers: 'No members yet.',
    applicationCount: ({ count }) =>
      `${count} ${Number(count) === 1 ? 'registration' : 'registrations'}`,
    idChip: 'ID {id}',
    prev: 'Previous',
    next: 'Next',
    selectPrompt: 'Select a member from the list.',
    subtitle: 'Member ID {id} · Joined {date}',
    edit: 'Edit',
    saving: 'Saving...',
    notSelected: 'Not selected',
    loadListError: 'Could not load members.',
    loadDetailError: 'Could not load member details.',
    saveError: 'Could not save member details.',
    requiredFields: 'Name and phone are required.',
    fields: {
      name: 'Name',
      phone: 'Phone',
      birth: 'Date of birth',
      gender: 'Gender',
      parentPhone: 'Parent/guardian phone',
      association: 'Association',
      gym: 'Gym',
      coach: 'Coach',
      grade: 'Grade',
      height: 'Height',
      heightCm: 'Height (cm)',
      memo: 'Admin memo',
    },
    required: '{label} *',
    records: {
      title: 'Tournament records ({count})',
      empty: 'No tournament records.',
      columns: {
        competition: 'Tournament',
        eventAt: 'Date',
        gym: 'Gym',
        grade: 'Grade',
        height: 'Height',
        division: 'Division',
        rank: 'Rank',
        record: 'Record',
        scoreSum: 'Total score',
        payment: 'Payment',
        matches: 'Matches',
      },
      matchCount: ({ count }) => `${count} ${Number(count) === 1 ? 'match' : 'matches'}`,
      rank: {
        first: '🥇 Champion',
        second: '🥈 Runner-up',
        third: '🥉 3rd',
        nth: ({ rank }) => {
          const n = Number(rank);
          const mod100 = n % 100;
          const suffix =
            mod100 >= 11 && mod100 <= 13 ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] ?? 'th';
          return `${rank}${suffix}`;
        },
      },
      winLoss: '{wins}W {losses}L',
      score: '{total} (Head {head} · Body {body})',
    },
    matches: {
      columns: {
        round: 'Round',
        opponent: 'Opponent',
        myScore: 'Score',
        opponentScore: 'Opponent score',
        result: 'Result',
      },
      result: {
        WIN: 'Win',
        LOSS: 'Loss',
        BYE: 'Bye',
        pending: 'Not played',
      },
    },
    merge: {
      title: 'Merge duplicate members',
      desc: 'If the same person was split into two members (e.g. a typo in the name), move this member’s registrations and tournament records to another member and delete this one.',
      targetPlaceholder: 'Target member ID',
      button: 'Merge',
      targetRequired: 'Please enter the target member ID to merge into.',
      confirm:
        'Move the registrations and tournament records of {name} (ID {id}) to member ID {targetId} and delete this member.\nContinue?',
      error: 'Could not merge members.',
    },
  },
};

export default members;
